import _ from "lodash";

import type { ActiveRouteType } from "utils/routeMatcher";

import ErrorLoggerService from "core/ErrorLoggerService";


import ROUTES_BASED_ON_CUSTOMER_STATUS from "../constants/ROUTES_BASED_ON_CUSTOMER_STATUS";

import routesObject from "../routesObject";

import type { CustomerStatusType } from "./normalizeCustomerDto";

interface AccessReturnType {
  accessGranted: boolean;
  redirectTo?: string;
}

const checkRouteAccess = (
  activeRoute: ActiveRouteType,
  customerStatus: CustomerStatusType
): AccessReturnType => {
  try {
    const authTypes = _.get(activeRoute, "authTypes", []);
    const authTypesForbidden = _.get(activeRoute, "authTypesForbidden", []);

    const isRoutePublic = _.isEmpty(authTypes) && _.isEmpty(authTypesForbidden);
    if (isRoutePublic) return { accessGranted: true };

    const userHasAccess = (_.includes(authTypes, customerStatus) || _.isEmpty(authTypes)) &&
      (!_.includes(authTypesForbidden, customerStatus) || _.isEmpty(authTypesForbidden));

    if (userHasAccess) {
      return { accessGranted: true };
    }
    else {
      return {
        accessGranted: false,
        redirectTo: _.get(
          ROUTES_BASED_ON_CUSTOMER_STATUS(),
          customerStatus ?? "",
          routesObject.home.url
        )
      };
    }
  }
  catch (err) {
    ErrorLoggerService("APP", "checkRouteAccess", err);
    return {
      accessGranted: false,
      redirectTo: routesObject.home.url
    };
  }
};

export default checkRouteAccess;
